import axios from './axios';

export interface ITestimonial {
	_id: string;
	content: {
		en: string;
		ru: string;
	};
	clientName: {
		en: string;
		ru: string;
	};
	company: {
		en: string;
		ru: string;
	};
	rating: number;
	featured: boolean;
	active: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface CreateTestimonialDto {
	content: {
		en: string;
		ru: string;
	};
	clientName: {
		en: string;
		ru: string;
	};
	company: {
		en: string;
		ru: string;
	};
	rating?: number;
	featured?: boolean;
	active?: boolean;
}

export interface UpdateTestimonialDto extends Partial<CreateTestimonialDto> {}

export interface QueryTestimonialDto {
	featured?: boolean;
	active?: boolean;
	rating?: number;
	search?: string;
	page?: number;
	limit?: number;
}

export interface TestimonialsResponse {
	testimonials: ITestimonial[];
	total: number;
	page: number;
	totalPages: number;
}

// Get all testimonials
export const getTestimonials = async (query?: QueryTestimonialDto): Promise<TestimonialsResponse> => {
	const response = await axios.get('/api/testimonials', { params: query });
	return response.data;
};

// Get featured testimonials
export const getFeaturedTestimonials = async (limit?: number): Promise<ITestimonial[]> => {
	const response = await axios.get('/api/testimonials/featured', { params: { limit } });
	return response.data;
};

// Get testimonial by ID
export const getTestimonialById = async (id: string): Promise<ITestimonial> => {
	const response = await axios.get(`/api/testimonials/${id}`);
	return response.data;
};

// Create testimonial
export const createTestimonial = async (data: CreateTestimonialDto): Promise<ITestimonial> => {
	const response = await axios.post('/api/testimonials', data);
	return response.data;
};

// Update testimonial
export const updateTestimonial = async (id: string, data: UpdateTestimonialDto): Promise<ITestimonial> => {
	const response = await axios.patch(`/api/testimonials/${id}`, data);
	return response.data;
};

// Delete testimonial
export const deleteTestimonial = async (id: string): Promise<void> => {
	await axios.delete(`/api/testimonials/${id}`);
};

// Toggle featured status
export const toggleFeaturedTestimonial = async (id: string, featured: boolean): Promise<ITestimonial> => {
	const response = await axios.patch(`/api/testimonials/${id}/toggle-featured`);
	return response.data;
};

// Toggle active status
export const toggleActiveTestimonial = async (id: string, active: boolean): Promise<ITestimonial> => {
	const response = await axios.patch(`/api/testimonials/${id}/toggle-active`);
	return response.data;
};

// Get testimonials statistics
export const getTestimonialsStats = async (): Promise<{
	total: number;
	featured: number;
	active: number;
	averageRating: number;
}> => {
	const response = await axios.get('/api/testimonials/stats');
	return response.data;
};